import FAQ from 'components/Section/FAQ'
import CTA from 'components/Section/EventCTA'
import styles from './FaqAndCTA.module.scss'

export default function FaqAndCTA({ section }) {
  const { faq, cta } = section

  if (!faq && !cta) {
    return null
  }

  /**
   * CTA often contains empty strings
   * Check if some content is set before rendering.
   */
  const ctaExists = () =>
    cta.tagline !== '' || cta.title !== '' || cta.content !== ''

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.wrap}>
          {ctaExists() && (
            <div className={styles.column}>
              <CTA section={cta} />
            </div>
          )}
          {faq && (
            <div className={styles.column}>
              <FAQ section={faq} />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}
